import getters from './getters.js'
import mutations from './mutations.js'
import actions from './actions.js'

export default {
  state: {
    // 各类型数目
    orderNumbers: {}
  },
  getters,
  mutations,
  actions
}
